module.exports = __webpack_public_path__ + "img/banner_left.a2bd9ed3.png";